import { SiteContactDetails } from "../../../../APIDocs/apiTypes"
import { CollapsibleCard } from "../../components/CollapsibleCard"
import { Label } from "../../components/Label"

interface props {
    contactDetails?: SiteContactDetails
    disableCollapse?: boolean
}

export const SiteContactCard = ({contactDetails, disableCollapse}: props) => {
    if (!contactDetails) return null;
    return (
        <CollapsibleCard identifier="siteContactDetails" title="Site Contact Details" disableCollapse={disableCollapse}>
            {contactDetails.Title && <Label title="Title" text={contactDetails.Title} />}
            {contactDetails.ContactFirstName && <Label title="First Name" text={contactDetails.ContactFirstName} />}
            {contactDetails.ContactSurname && <Label title="Surname" text={contactDetails.ContactSurname} />}
            {contactDetails.ContactNumber && <Label title="Number" text={contactDetails.ContactNumber} />}
            {contactDetails.EmailAddress && <Label title="Email" text={contactDetails.EmailAddress} />}
        </CollapsibleCard>
    )
}
